/* src/app/dynamic-forms/form-view/form-view-search/form-view-search.component.css */
.mat-mdc-form-field {
  display: inline;
  width: 100%;
}
full-width {
  width: 100%;
}
.tdstyle {
  width: 10%;
}
.tdstyle-desc {
  width: 90%;
}
.data-object {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 5px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.data-object-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.left {
  width: 30%;
}
/*# sourceMappingURL=form-view-search.component.css.map */
